import type { Metadata } from 'next';
import { isCsShotUzHost } from '../runtime/host';

// WHY: служебные экраны закрыты noindex в мета-теге и заголовке, а не в robots.txt — адрес под Disallow робот не читает,
// noindex не видит и индексирует его по внешним ссылкам; корень закрывает и всё под ним, как префикс в прежнем Disallow
const SERVICE_SCREEN_ROOTS = [
  '/login',
  '/inventory',
  '/referrals',
  '/case-battles/create',
  '/exchange',
  '/profile',
  '/settings',
  '/payment',
  '/promocode',
  '/wheel',
  '/xp',
  '/onboarding',
  '/games/rush-mid',
];

const CASE_SERVICE_SCREEN = /^\/cases\/[^/]+\/(open|results)(\/|$)/;

export const SERVICE_SCREEN_ROBOTS = { index: false, follow: false } as const satisfies Metadata['robots'];

export const NOINDEX_X_ROBOTS_TAG = 'noindex, nofollow';

export const isServiceScreen = (appPath: string): boolean =>
  SERVICE_SCREEN_ROOTS.some((root) => appPath === root || appPath.startsWith(`${root}/`)) || CASE_SERVICE_SCREEN.test(appPath);

// WHY: реквизиты продавца показывает только cs-shot.uz — на остальных хостах «Контакты» нет в подвале, а сама страница
// закрыта от индекса и не попадает в карту сайта
const CS_SHOT_UZ_ONLY_PAGES = ['/contacts'];

export const isClosedForHost = (appPath: string, host: string): boolean =>
  CS_SHOT_UZ_ONLY_PAGES.includes(appPath) && !isCsShotUzHost(host);

export const isNoindexScreen = (appPath: string, host: string): boolean =>
  isServiceScreen(appPath) || isClosedForHost(appPath, host);
